import { Component } from '@angular/core';
import { PropertyOverviewWidget } from '../property-overview-widget/property-overview-widget';

@Component({
  selector: 'app-property-details-page',
  imports: [ PropertyOverviewWidget],
  templateUrl: './property-details-page.html',
  styleUrl: './property-details-page.scss'
})
export class PropertyDetailsPage {

}
